export default function Regole3p() {

    return(
        <div className=" xl:mx-24 " >
            <div className="sm:flex lg:px-16 p-4 justify-center items-center">
                <div className="flex-col sm:w-1/2 p-4">
                    <h1 className="text-4xl font-bold"><span className="text-6xl text-logo-color">P</span>rogettazione</h1>
                    <p className="mt-1 text-lg">serramenti su misura.</p>
                    <p className="mt-8 text-lg">Il nostro tecnico arriverà in casa vostra per valutare al meglio la scelta del serramento perfetto per voi.</p>
                    <p className="mt-4 text-lg">Prenderà poi le misure per poter procedere alla realizzazione su misura dell'infisso, creando un serramento ad hoc per ogni esigenza.</p>
                </div>
                <div className="sm:w-1/2 rounded-xl p-4">
                <img src="./images/misure.jpg" alt="Progettazione" 
     className="w-full h-98 sm:h-98 lg:h-144 object-cover rounded-xl shadow-2xl shadow-logo-color" />

                </div>
                
            </div>
            <div className="flex flex-col-reverse sm:flex-row lg:px-16 p-4 justify-center items-center">
                <div className="sm:w-1/2 rounded-xl p-4">
                    <img src="./images/precizione.jpg" alt="Progettazione" 
                         className="w-full h-98 sm:h-98 lg:h-144 object-cover rounded-xl shadow-2xl shadow-logo-color" />


                </div>
                <div className="flex-col sm:w-1/2 p-4">
                    <h1 className="text-4xl font-bold"><span className="text-6xl text-logo-color">P</span>recisione</h1>
                    <p className="mt-1 text-lg">dalla consulenza alla posa finale.</p>
                    <p className="mt-8 text-lg">I nostri tecnici saranno a completa disposizione dall'inizio alla fine dei lavori, affinchè la consulenza e la posa dei vostri infissi
                        vengano svolte con la massima precisione.
                    </p>
                </div>
                
            </div>

            <div className="sm:flex lg:px-16 p-4 justify-center items-center">
                <div className="flex-col sm:w-1/2 p-4">
                    <h1 className="text-4xl font-bold"><span className="text-6xl text-logo-color">P</span>ulizia</h1>
                    <p className="mt-1 text-lg">accurata dei serramenti e lavaggio dei vetri al termine di ogni posa in opera, offrendo così un servizio completo a 360 gradi.</p>

                    <p className="mt-4 text-lg">In questo modo, &nbsp;
                        <span className="font-semibold border-2 border-logo-color text-logo-color1 rounded-xl p-1">DOT Serramenti</span> 
                     &nbsp; garantisce la massima cura degli ambienti di lavoro e 
                        delle vostre case in tutte le fasi del lavoro.</p>
                </div>
                <div className="sm:w-1/2 rounded-xl p-4">
                <img src="./images/pulizia.webp" alt="Progettazione" 
                className="w-full h-98 sm:h-98 lg:h-144 object-cover rounded-xl shadow-2xl shadow-logo-color" />


                </div>
                
            </div>
        </div>
    )
}